import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import BottomShape from '@/components/Layout/Header/Search/Suggestions/Badge/Top10/Bottomshape';

interface Props {
  className?: string;
}

const Top10: FC<Props> = ({ className }) => {
  return (
    <div className={twMerge(className)}>
      <div className='py-1 px-0.5 bg-orangeZl-500 flex-col  w-[25px] h-[28px] items-end gap-1 text-white'>
        <p className='text-[10px]/[10px] font-medium text-center'>TOP</p>
        <p className='text-[12px]/[12px] tracking-[-2%] font-semibold text-center'>
          10
        </p>
      </div>
      <BottomShape className='absolute bottom-[-12px] right-0' />
    </div>
  );
};

export default Top10;
